import axios from "axios";
import secureLocalStorage from "react-secure-storage";
// Update theme
export const update_theme = async (theme_mode) => {
    const response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/update-theme",{
        theme_mode:theme_mode
    })
  return response.data;
}